/** Auto-generated by scripts/sync-dev-build-meta.js — do not edit manually */
export const devGitBranch = 'feature/1456-approval-workflow';
export const devGitShortSha = '4b24b0a18';
export const devGitWorktreeTag = 'wt-729fd10';
